import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type ToggleCategoryPayload = {
	itemCategoryId: string;
	isDeleted: boolean;
};

const toggleCategoryActive = async (payload: ToggleCategoryPayload): Promise<any> => {
	const response = await apiDal.post("/categories/toggle", payload);
	return response.data;
};

export const useToggleCategoryActive = () => {
	return useMutation({
		mutationFn: toggleCategoryActive,
	});
};
